import { Alert, AlertIcon, Box, CloseButton, Text } from "@chakra-ui/react";

interface ToastProps {
  title: string;
  status: "error" | "success" | "info";
  onClose?: () => void;
}

export const Toast = ({ title, status, onClose }: ToastProps) => {
  const statusColors = {
    success: "semantic.success.main",
    info: "brand.analytic",
    error: "semantic.error.main",
  } as const;

  const bgColor = statusColors[status];

  return (
    <Box
      bg={bgColor}
      color="white"
      p={4}
      borderRadius="md"
      boxShadow="lg"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Alert status={status} variant="solid" bg="transparent">
        <AlertIcon color="brand.grey.100" />
        <Box flex="1">
          <Text mb={0} fontWeight="bold" color="brand.grey.300">
            {title}
          </Text>
        </Box>
      </Alert>
      {onClose && <CloseButton color="brand.grey.300" onClick={onClose} position="relative" />}
    </Box>
  );
};
